export default {
	badge: {
		googleplay: require('./googleplay.svg'),
		appstore: require('./appstore.svg')
	},
	appIcon: require('./appicon.png'),
	screenshots: require('./screenshots.png'),
	gallery: [
		require('./gallery/1.jpg'),
		require('./gallery/2.jpg'),
		require('./gallery/3.jpg'),
		require('./gallery/4.jpg'),
		require('./gallery/5.jpg'),
		require('./gallery/6.jpg'),
	]
}